import { chipClasses } from '@mui/material'
import { blue, gray, green, orange, purple, red, uiColors } from '~/common/styles/colors'
import { ChipColor, ChipVariant } from '~/components/ui/atoms/chip/types'

export function getChipColorPrimitives(variant: ChipVariant, color: ChipColor) {
  switch (`${variant}-${color}`) {
    case 'solid-blue': {
      return {
        backgroundColor: blue[2],
        color: uiColors.content.primary,
        borderColor: blue[3],
        circleColor: blue[9],
        hoverColor: blue[3],
        borderHoverColor: blue[4],
      }
    }
    case 'outlined-blue': {
      return {
        backgroundColor: blue[2],
        color: uiColors.content.primary,
        borderColor: blue[10],
        circleColor: blue[9],
        hoverColor: blue[3],
        borderHoverColor: blue[11],
      }
    }
    case 'solid-orange': {
      return {
        backgroundColor: orange[4],
        color: uiColors.content.primary,
        borderColor: orange[5],
        circleColor: orange[9],
        hoverColor: orange[5],
        borderHoverColor: orange[6],
      }
    }
    case 'outlined-orange': {
      return {
        backgroundColor: orange[4],
        color: uiColors.content.primary,
        borderColor: orange[10],
        circleColor: orange[9],
        hoverColor: orange[5],
        borderHoverColor: orange[11],
      }
    }
    case 'solid-purple': {
      return {
        backgroundColor: purple[4],
        color: uiColors.content.primary,
        borderColor: purple[5],
        circleColor: purple[9],
        hoverColor: purple[5],
        borderHoverColor: purple[6],
      }
    }
    case 'outlined-purple': {
      return {
        backgroundColor: purple[4],
        color: uiColors.content.primary,
        borderColor: purple[10],
        circleColor: purple[9],
        hoverColor: purple[5],
        borderHoverColor: purple[11],
      }
    }
    case 'solid-green': {
      return {
        backgroundColor: green[4],
        color: uiColors.content.primary,
        borderColor: green[5],
        circleColor: green[9],
        hoverColor: green[5],
        borderHoverColor: green[6],
      }
    }
    case 'outlined-green': {
      return {
        backgroundColor: green[4],
        color: uiColors.content.primary,
        borderColor: green[10],
        circleColor: green[9],
        hoverColor: green[5],
        borderHoverColor: green[11],
      }
    }
    case 'solid-red': {
      return {
        backgroundColor: red[4],
        color: uiColors.content.primary,
        borderColor: red[5],
        circleColor: red[9],
        hoverColor: red[5],
        borderHoverColor: red[6],
      }
    }
    case 'outlined-red': {
      return {
        backgroundColor: red[4],
        color: uiColors.content.primary,
        borderColor: red[10],
        circleColor: red[9],
        hoverColor: red[5],
        borderHoverColor: red[11],
      }
    }
    case 'solid-gray': {
      return {
        backgroundColor: gray[2],
        color: uiColors.content.primary,
        borderColor: gray[4],
        circleColor: gray[9],
        hoverColor: gray[2],
        borderHoverColor: gray[3],
      }
    }
    case 'outlined-gray': {
      return {
        backgroundColor: gray[2],
        color: uiColors.content.primary,
        borderColor: gray[10],
        circleColor: gray[9],
      }
    }
    case 'ghost-gray': {
      return {
        backgroundColor: gray[2],
        hoverColor: gray[3],
        color: gray[9],
        borderColor: gray[4],
        borderHoverColor: gray[6],
        circleColor: gray[9],
      }
    }
  }

  return null
}

export function getChipBasePrimitives(
  variant: ChipVariant,
  color: ChipColor,
  isRounded = false,
  noPadding = false,
) {
  const colorPrimitives = getChipColorPrimitives(variant, color)

  let padding: string
  let height: string
  if (noPadding) {
    padding = '2px 2px'
    height = '16px'
  } else {
    height = '24px'
    padding = isRounded ? '0 8px' : '4px 8px'
  }

  return {
    display: 'inline-flex',
    gap: '4px',
    alignItems: 'center',
    borderWidth: '1px',
    borderStyle: 'solid',
    height,
    padding,
    borderRadius: isRounded ? '100px' : '4px',
    [`& .${chipClasses.disabled}`]: {
      color: uiColors.content.disabled,
      backgroundColor: uiColors.background.disabled,
    },
    [`& .${chipClasses.deleteIcon}`]: {
      color: uiColors.content.primary,
      marginInlineStart: '4px',
      marginInlineEnd: '0px',
      '&:hover': {
        color: gray[9],
      },
    },
    [`&:hover`]: {
      backgroundColor: colorPrimitives?.hoverColor,
      borderColor: colorPrimitives?.borderHoverColor,
    },
    [`& .${chipClasses.label}`]: {
      padding: '0px',
    },
    [`& .${chipClasses.icon}`]: {
      marginInlineEnd: '4px',
      marginInlineStart: '0px',
    },
  }
}
